module.exports = __webpack_public_path__ + "img/home_collections_de.4b5a6c2.png";